<template>
    <div class = "blog-card m-5" v-on:click="showEventCard">
        <img v-if="event.ThumbnailUrl" :src="event.ThumbnailUrl" />
        <img v-else :src="emptyImageUrl" class="img-thumbnail" />
        <a class="learnButton" v-on:click="showEventCard">Learn More...</a>
    </div>

    <!-- Modal content -->
    <div class="eventmodal" :style="{display: modalDisplay}">
        <div class="eventmodal-content">
        <!-- Name -->
        <h5 class="emodal-text">{{event.Name}}</h5>
        <table class="eventtable">
            <!-- StartTime -->
            <tr>
            <th style="border-bottom: 1px solid #ddd; border-right: 1px solid #ddd; padding: 15px; width: 30%;">Event Schedule</th>
            <td  style="border-bottom: 1px solid #ddd; padding: 15px;">{{ formatDate }}</td>
            </tr>
            <!-- Platform -->
            <tr>
            <th style="border-bottom: 1px solid #ddd; border-right: 1px solid #ddd; padding: 15px; width: 30%;">Platform</th>
            <td style="border-bottom: 1px solid #ddd; padding: 15px;">{{ event.Platform }}</td>
            </tr>
            
            <!-- Description -->
            <tr>
            <th style="border-right: 1px solid #ddd; padding: 15px;">Event Description</th>
            <td style="padding: 15px;"> {{ event.Description }}
            </td>
            </tr>
        </table>
        <div>
            <router-link :to="`/apply-volunteer/${event.id}`" class="backButton">
            <a>Sign Up</a>
            </router-link>
            <a class="backButton" v-on:click="hideEventCard">Back</a></div>
        </div>
    </div>
    

</template>

<script>
export default {
    data (){
        return {
            modalDisplay: "none",
        }
       
    },
    props: ['event'],

    methods: {
        showEventCard() {
            this.modalDisplay = "block";
        },
        hideEventCard(){
            this.modalDisplay = "none";
        }
    },

    computed: {
        formatDate() {
            const startTime = this.event.StartTime;
            const currDate = startTime.seconds * 1000 + startTime / 1000000;
            const date = new Date(currDate);
            return date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' }) + " | " + date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
        }
    }
}
</script>


<style scoped src="@/assets/css/globalStyle.css"></style>
<style scoped src="@/assets/css/home.css"></style>